<template>
  <div class="container">
    <van-search
      v-model="searchKey"
      placeholder="搜索活动或主办方名称"
      @search="searchTap"
      @clear="searchTap"
    />
    <van-swipe class="swiper" :autoplay="5000" indicator-color="white">
      <van-swipe-item v-for="(item, i) in banners" :key="i">
        <van-image :src="item" fit="cover" />
      </van-swipe-item>
    </van-swipe>
    <van-row class="type-wrap">
      <!-- <van-col span="6" @click="typeTap">
        <span>{{ type ? type : '类型' }}</span>
        <van-icon name="play" />
      </van-col> -->
      <van-col span="8" @click="statusTap">
        <span>{{ statusText ? statusText : '状态' }}</span>
        <van-icon name="play" />
      </van-col>
      <van-col span="8" @click="addressTap">
        <span>{{ addressText ? addressText : '区域' }}</span>
        <van-icon name="play" />
      </van-col>
      <van-col span="8" @click="timeTap">
        <span>时间</span>
        <van-icon name="play" />
      </van-col>
    </van-row>
    <van-list
      v-if="listShow"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      offset="10"
      @load="onLoad"
    >
      <list-com
        v-for="(item, i) in lists"
        :key="i"
        :item="item"
        @listUp="listUp"
      ></list-com>
    </van-list>
    <van-empty
      v-else
      class="custom-image"
      image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
      description="暂无数据"
    />
    <!-- 类型选择弹窗 -->
    <van-popup v-model="typePicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="typeColumns"
        @cancel="typePicker = false"
        @confirm="typeConfirm"
      />
    </van-popup>
    <!-- 状态选择弹窗 -->
    <van-popup v-model="statusPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="statusColumns"
        @cancel="statusPicker = false"
        @confirm="statusConfirm"
      />
    </van-popup>
    <!-- 区域选择弹窗 -->
    <van-popup v-model="addressPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="addressColumns"
        value-key="county"
        @cancel="addressPicker = false"
        @confirm="addressConfirm"
      />
    </van-popup>
    <van-popup
      class="calendar-popup"
      v-model="timePicker"
      round
      position="bottom"
    >
      <van-calendar
        class="calendar"
        ref="calendar"
        color="#1989fa"
        :poppable="false"
        type="range"
        :min-date="new Date(2021, 1, 1)"
        :show-confirm="false"
        @confirm="timeConfirm"
      />
      <van-button class="calendar-btn" type="info" @click="timeCancel"
        >重 置</van-button
      >
    </van-popup>
  </div>
</template>
<script>
import { formatDate, formatDate1 } from '../../../../common/utils/time.js'
import listCom from '../components/listCom'
import { getActivityDataByPage } from '@api/lishui/active'
import { getArea } from '@api/lishui/live'
import { Toast } from 'vant'
export default {
  components: { listCom },
  data() {
    return {
      searchKey: '',
      // 轮播图
      banners: [require('../../../../assets//banner.jpg')],
      type: '', // 类型
      status: '', // 状态
      statusText: '',
      areaCode: '', // 区域
      addressText: '',
      startTime: '', // 时间
      endTime: '',
      typePicker: false,
      typeColumns: ['政策解读', '会议直播', '技术分享', '企业分享'],
      statusPicker: false,
      statusColumns: [
        {
          text: '全部',
          value: ''
        },
        {
          text: '未开始',
          value: 1
        },
        {
          text: '进行中',
          value: 2
        },
        {
          text: '已结束',
          value: 3
        }
      ],
      addressPicker: false,
      addressColumns: [],
      timePicker: false,
      loading: true,
      finished: false,
      listShow: true,
      lists: [],
      pageSize: 10,
      pageNum: 1
    }
  },
  mounted() {
    this.getAreaList()
    this.getList()
  },
  methods: {
    listUp() {
      this.getList(1)
    },

    getAreaList() {
      getArea().then(res => {
        this.addressColumns = [
          {
            code: '',
            county: '全部'
          },
          ...res.data.data
        ]
      })
    },
    getList(num) {
      if (num) {
        this.pageNum = num
        this.lists = []
      }
      const params = {
        areaCode: this.areaCode,
        searchKey: this.searchKey,
        status: this.status,
        startTime: this.startTime,
        endTime: this.endTime,
        pageSize: this.pageSize,
        pageNum: this.pageNum
      }
      getActivityDataByPage(params).then(res => {
        const { code, data, msg } = res.data
        if (code == '0000') {
          if (data.results) {
            data.results.forEach(item => {
              switch (item.status) {
                case 1:
                  item.statusText = '未开始'
                  break
                case 2:
                  item.statusText = '进行中'
                  break
                case 3:
                  item.statusText = '已结束'
                  break
              }
              this.lists.push(item)
            })
          }
          this.loading = false
          if (!data.results || data.results.length < 10) {
            this.finished = true
          } else {
            this.finished = false
          }
          if (this.lists.length == 0) {
            this.listShow = false
          } else {
            this.listShow = true
          }
        } else {
          Toast(msg)
        }
      })
    },
    // 触底加载更多
    onLoad() {
      this.pageNum++
      this.getList()
    },
    // 搜索
    searchTap(e) {
      this.getList(1)
    },
    typeTap() {
      this.typePicker = true
    },
    // 类型切换
    typeConfirm(e) {
      console.log(e)
      this.type = e
      this.typePicker = false
    },
    statusTap() {
      this.statusPicker = true
    },
    // 状态切换
    statusConfirm(e) {
      this.status = e.value
      this.statusText = e.text
      this.getList(1)
      this.statusPicker = false
    },
    addressTap() {
      this.addressPicker = true
    },
    // 区域切换
    addressConfirm(e) {
      this.areaCode = e.code
      this.addressText = e.county
      this.getList(1)
      this.addressPicker = false
    },
    timeTap() {
      this.timePicker = true
    },
    // 时间切换
    timeCancel() {
      this.timePicker = false
      this.startTime = ''
      this.endTime = ''
      this.$refs.calendar.reset()
      this.getList(1)
    },
    timeConfirm(e) {
      this.startTime = formatDate(e[0])
      this.endTime = formatDate(e[1])
      this.getList(1)
      this.timePicker = false
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  padding-bottom: 50px;
}
.van-search {
  padding: 10px 0.4rem;
  z-index: 10;
  position: sticky;
  top: 0;
  .van-search__content {
    border-radius: 20px;
  }
  /deep/.van-cell__value {
    padding: 0 4px;
  }
}
.swiper {
  height: 150px;
  .van-swipe-item {
    .van-image {
      width: 100%;
      height: 100%;
    }
  }
  /deep/.van-swipe__indicator {
    width: 12px;
    height: 2px;
    border-radius: 4px;
  }
}
.type-wrap {
  width: 100%;
  background: #fff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom: 1px solid #eee;
  margin-top: -20px;
  position: relative;
  z-index: 10;
  .van-col {
    text-align: center;
    padding: 8px 0;
    span {
      font-size: 14px;
    }
    .van-icon {
      font-size: 14px;
      color: #ccc;
      transform: rotate(90deg);
      margin-left: 4px;
    }
  }
}
.calendar-popup {
  // border-radius: 0;
  .calendar {
    height: 80vh;
  }
  .calendar-btn {
    width: 100%;
    margin-top: 10px;
  }
}
/deep/.custom-image .van-empty__image {
  width: 90px;
  height: 90px;
  margin-top: 20%;
}
</style>
